import { forwardRef, useImperativeHandle, useState } from 'react'
import { t } from 'i18next'

import { DocumentosPermitidos } from 'src/enums/EscritosLegales'
import useInputFile from 'src/hooks/useInputFile'
import useNewModal from 'src/hooks/useModal'
import { Document, Expedient } from 'src/interfaces/lexon'
import { getDocument } from 'src/services/Lexon/DocumentService'
import DialogDocument from './Dialog/DialogDocument'
import DialogSelectorDocument from './Dialog/DialogSelectorDocument'

export type LexonDocumentsRefType = {
  open: () => void
}

type Props = {
  id: string
  disabled?: boolean
  principal?: boolean
}

export default forwardRef<LexonDocumentsRefType, Props>(function(props: Props, ref): JSX.Element {
  const { id, disabled = false, principal = true } = props
  const { isOpened, close, open } = useNewModal()
  const { isOpened: isOpenedDoc, close: closeDoc, open: openDoc } = useNewModal()

  const [inputSearch, setInputSearch] = useState('')
  const [selectedExpedient, setSelectedExpedient] = useState<Expedient | null>(null)
  const [selectedDocument, setSelectedDocument] = useState<Document | null>(null)

  const { setInputFile } = useInputFile({
    id,
    multiple: !principal
  })

  function clear() {
    setInputSearch('')
    setSelectedExpedient(null)
    setSelectedDocument(null)
  }

  function next() {
    close()
    openDoc()
  }

  function prev() {
    closeDoc()
    open()
  }

  function exit() {
    close()
    closeDoc()
    clear()
  }

  function handleSelectDocument(row): void {
    setSelectedDocument(row?.[0]?.original)
  }

  async function handleSelection() {
    if (selectedDocument) {
      getDocument(selectedDocument).then(res => {
        setInputFile(res)
      })
    }
    exit()
  }

  const title = principal
    ? t('dialog.title.select_document')
    : t('dialog.title.select_document_anexo')

  const tooltip = principal
    ? t('tooltips.select_lexon_document')
    : t('tooltips.select_lexon_document_anexo')

  useImperativeHandle(
    ref,
    () => ({
      open
    }),
    [open]
  )

  return (
    <>
      <DialogSelectorDocument
        title={title}
        isOpened={isOpened}
        next={next}
        close={exit}
        inputSearch={inputSearch}
        setInputSearch={setInputSearch}
        selectedExpedient={selectedExpedient}
        setSelectedExpedient={setSelectedExpedient}
      />
      <DialogDocument
        title={title}
        prev={prev}
        isOpened={isOpenedDoc}
        close={exit}
        onSelection={handleSelection}
        selectedDocument={selectedDocument}
        setSelectedDocument={handleSelectDocument}
        inputSearch={inputSearch}
        expedientSelected={selectedExpedient}
        extAllowed={principal ? DocumentosPermitidos.PRINCIPAL : DocumentosPermitidos.ANEXOS}
      />
    </>
  )
})
